import accountReducer, { defaultState as accountdefaultState } from "./session/account";
import * as accountAction from "~/actions/account";

const defaultState = {
    userAuth: {
        ...accountdefaultState
    }
}

interface Iaction { type: string, payload: any }


export default function(state = defaultState, action:Iaction) {
    if (accountAction.hasActionsType(action.type)) return { ...state, userAuth: accountReducer(state.userAuth, action)}

    switch(action.type) {
        default: return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/session.ts